import { DEFAULT_LOCALE, isLocale, type Locale } from "./config";

// Todas las URLs del sitio llevan prefijo de idioma: /es/eventos, /en/eventos.
// Las viejas sin prefijo las redirige proxy.ts (301).

// "/eventos?x=1" → "/en/eventos?x=1". Deja tal cual lo externo (http...,
// mailto:, //cdn), los anclas (#id) y lo que ya trae prefijo.
export function localizePath(path: string, lang: Locale): string {
  if (!path.startsWith("/") || path.startsWith("//")) return path;
  const { lang: existing } = splitLocale(path);
  if (existing) return path;
  return path === "/" ? `/${lang}` : `/${lang}${path}`;
}

// "/en/eventos" → { lang: "en", path: "/eventos" }; "/eventos" → { lang: null, path: "/eventos" }.
export function splitLocale(pathname: string): { lang: Locale | null; path: string } {
  const match = /^\/([^/?#]+)(.*)$/.exec(pathname);
  if (match && isLocale(match[1])) {
    const rest = match[2];
    return { lang: match[1], path: rest === "" || rest.startsWith("?") || rest.startsWith("#") ? `/${rest}` : rest };
  }
  return { lang: null, path: pathname };
}

// Misma página en otro idioma (para el selector de idioma).
export function switchLocalePath(pathname: string, to: Locale): string {
  return localizePath(splitLocale(pathname).path, to);
}

export function defaultLocalePath(path: string): string {
  return localizePath(path, DEFAULT_LOCALE);
}
